<template>
  <div class="support-footer-playground">

    <support-footer />

  </div>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'SupportFooterPlayground',
  components: {
    SupportFooter: BaseUI.SupportFooter,
  },
};
</script>

<style lang="scss" scoped>

  .support-footer-playground {
    direction: rtl;
  }
</style>



// WEBPACK FOOTER //
// src/pages/base-ui-playground/components/SupportFooterPlayground.vue